import { RefObject, useEffect } from "react";

/** Calls onClose when a pointerdown occurs outside both the container ref and a popover element. */
export function useOutsideClickClose({
  enabled,
  containerRef,
  popoverElementId,
  onClose,
}: {
  enabled: boolean;
  containerRef: RefObject<HTMLElement | null>;
  popoverElementId: string;
  onClose: () => void;
}): void {
  useEffect(() => {
    if (!enabled) return;

    const handlePointerDown = (e: PointerEvent) => {
      const target = e.target as HTMLElement;
      if (containerRef.current?.contains(target)) return;

      const popoverEl = document.getElementById(popoverElementId);
      if (popoverEl?.contains(target)) return;

      onClose();
    };

    document.addEventListener("pointerdown", handlePointerDown);

    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [enabled, containerRef, popoverElementId, onClose]);
}
